import FallbackHelper from '../../AAFPlayer/helpers/FallbackHelper';

var FallbackUtil = (function() {
  var idFallbackTimeout = null;
  var callbackFallback = null;
  let outputParamsTemp = null;
  let error = null;
  var setCallbackFallback = function(callback) {
    callbackFallback = callback;
  };

  const getOutputParams = () => {
    return outputParamsTemp;
  }

  const setError = (err) => {
    error = err;
  }

  const getError = () => {
    return error;
  }

  var setFallbackTimeout = function(outputParams) {
    if(outputParams){
      outputParamsTemp = {...outputParams};
    }

    const fallbackIntervalTime = FallbackHelper.getFallbackIntervalTime();
    clearFallback();
    idFallbackTimeout = setTimeout(callbackFallback, fallbackIntervalTime, outputParams);
  };

  var clearFallback = function() {
    if (idFallbackTimeout) {
      clearTimeout(idFallbackTimeout);
    }
    outputParamsTemp = null;
    idFallbackTimeout = null;
  };

  return {
    setCallbackFallback,
    setFallbackTimeout,
    clearFallback,
    setError,
    getError,
    getOutputParams
  };
})();

export default FallbackUtil;



// WEBPACK FOOTER //
// ./src/components/Video/FallbackUtil.js